import React from 'react';
import { FormDialog } from '../../../form-dialog/form-dialog';

export interface ISkippedItem {
  id: string;
  name: string;
  reason: string;
}

export interface ICourseBulkEditResultDialogComponentProps {
  title: string;
  summary: string[];
  skippedItemsText: (count: number) => string;
  skippedItems: ISkippedItem[];
  onClose: () => void;
}

export function CourseBulkEditResultDialogComponent({ title, summary, skippedItemsText, skippedItems, onClose }: ICourseBulkEditResultDialogComponentProps) {
  return (
    <FormDialog open title={title} confirmButtonText="Luk" onConfirmClick={onClose} onClose={onClose} maxWidth="sm" fullWidth>
      {summary.map(line => (
        <p key={line}>{line}</p>
      ))}
      {skippedItems.length > 0 && (
        <>
          <p>{skippedItemsText(skippedItems.length)}</p>
          <ul>
            {skippedItems.map(skipped => (
              <li key={skipped.id}>
                {skipped.name}: {skipped.reason}
              </li>
            ))}
          </ul>
        </>
      )}
    </FormDialog>
  );
}
